import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Col, Grid, Row } from "react-bootstrap";
import Swal from "sweetalert2";
import toastr from "toastr";

import {
  DeleteFile,
  GetChecksum,
  GetFileTypes,
  GetList,
  UpdateFile,
  UploadFile,
  DownloadReleaseNotes,
  GetLanguageCodes,
} from "./action";
import Loader from "../../Loader";
import { Firmwares } from "./Firmwares";
import { FormMode } from "../../../constant";
import FirmwareModal from "./firmware-modal";
import { Order } from "../../../constant";
import { FirmwaresActivityLogsPath } from "routes/paths";
import {
  ROLENAMES,
  FIRMWARE_KEY,
} from "provider/PermissionProvider/permissions";

import { getProductOptions } from "../user-management/UserFormModalV2/ProductAccessDetails/actions";

const FirmwareView = (props) => {
  const [isInitializing, setIsIntializing] = useState(false);
  const [showFirmwareModal, setShowFirmwareModal] = useState(false);
  const [formMode, setFormMode] = useState(FormMode.Add);
  const [selectedFirmware, setSelectedFirmware] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [languageCodes, setLanguageCodes] = useState([]);
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState({
    pagination: { currentPage: 1, pageSize: 10 },
    orderBy: Order.asc,
    search: "",

    searchBy: 0,
    operation: 0,
  });

  useEffect(() => {
    setIsIntializing(true);

    props.GetList(filter).then(() => {
      setIsIntializing(false);
      props.GetFileTypes().then(() => {
        setIsLoading(false);
      });
    });
    props.GetLanguageCodes().then((languageCodes) => {
      setLanguageCodes(languageCodes);
    });
    props.getProductOptions(ROLENAMES[FIRMWARE_KEY].id).then((products) => {
      setProducts(products.filter((product) => product.isFullAccess));
    });
  }, []);

  const toggleFirmwareModal = () => {
    setShowFirmwareModal(!showFirmwareModal);
  };

  const handleUploadFirmware = () => {
    setFormMode(FormMode.Add);
    toggleFirmwareModal();
  };

  const handleUpdateFirmware = (row) => {
    setFormMode(row.isEditable ? FormMode.Edit : FormMode.View);
    setSelectedFirmware(row);
    toggleFirmwareModal();
  };

  const handleDeleteFirmware = (row) => {
    Swal.fire({
      title: "Delete firmware?",
      text: `Do you really want to delete '${row.fileName}'?`,
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No",
      reverseButtons: true,
      focusConfirm: false,
      focusCancel: true,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          return await props.DeleteFile(row.id);
        } catch (error) {
          Swal.fire(
            "An error has occurred",
            "An unexpected error has occurred. Please try again later.",
            "error"
          );
        }
      },
    }).then(async (response) => {
      if (response.value) {
        if (response.value.isSuccess) {
          Swal.fire(
            "Deleted!",
            `File ${row.fileName} sucessfully deleted.`,
            "success"
          );
          await props.GetList(filter);
        } else {
          // TODO: bug on error message
          Swal.fire(
            "An error has occurred",
            response.value.payload.error,
            "error"
          );
        }
      }
    });
  };

  const handleUploadFirmwareSubmit = async (formData, fileName) => {
    await props
      .UploadFile(formData)
      .then(async (response) => {
        if (response.isSuccess) {
          toggleFirmwareModal();
          toastr.info(`File ${fileName} uploaded successfully.`, "Upload");

          await props.GetList(filter);
        }
      })
      .catch((response) => {
        response.then((errorResponse) =>
          toastr.error(`${errorResponse.error}`, "Error")
        );
      });
  };

  const handleUpdateFirmwareSubmit = async (file, fileName) => {
    const response = await props.UpdateFile(file);
    if (response.isSuccess) {
      toggleFirmwareModal();
      toastr.info(`File ${fileName} successfully updated.`, "Update");

      await props.GetList(filter);
    } else {
      toastr.error(`${response.payload.error}`, "Error");
    }
  };

  const onReleaseNotesDownload = (filename) => {
    props.DownloadReleaseNotes(filename);
  };

  const refreshFileList = (newFilter) => {
    setIsLoading(true);
    setFilter(newFilter);
    props.GetList(newFilter).then(() => {
      setIsLoading(false);
    });
  };

  const onHandleSearch = async (searchCriteria) => {
    const newFilter = {
      ...filter,
      search: searchCriteria.searchText,
      searchBy: searchCriteria.searchBy,
      operation: searchCriteria.operation,
      pagination: {
        ...filter.pagination,
        currentPage: 1,
      },
    };

    refreshFileList(newFilter);
  };

  const onHandleTableChange = async (type, state) => {
    let newFilter = {
      ...filter,
      pagination: {
        ...filter.pagination,
        currentPage: state.page,
        pageSize: state.sizePerPage,
      },
    };
    if (type === "sort") {
      newFilter = {
        ...filter,
        orderBy: state.sortOrder === "desc" ? Order.desc : Order.asc,
      };
    }

    refreshFileList(newFilter);
  };

  if (isInitializing) {
    return <Loader fullpage message="Loading firmwares" />;
  }

  return (
    <Grid fluid>
      <h1>Firmwares</h1>
      <Row>
        <Col sm={12}>
          <Firmwares
            files={props.files}
            onUploadFirmware={handleUploadFirmware}
            onUpdateFirmware={handleUpdateFirmware}
            onDeleteFirmware={handleDeleteFirmware}
            onToggleActivityLogs={() =>
              props.history.push(FirmwaresActivityLogsPath)
            }
            isLoading={isLoading}
            onHandleSearch={onHandleSearch}
            onHandleTableChange={onHandleTableChange}
            pagination={filter.pagination}
          />
        </Col>
      </Row>
      <FirmwareModal
        show={showFirmwareModal}
        formMode={formMode}
        fileTypes={props.fileTypes}
        selectedFirmware={selectedFirmware}
        onModalClose={toggleFirmwareModal}
        onGetChecksum={props.GetChecksum}
        onUploadFirmwareSubmit={handleUploadFirmwareSubmit}
        onUpdateFirmwareSubmit={handleUpdateFirmwareSubmit}
        onReleaseNotesDownload={onReleaseNotesDownload}
        languageCodes={languageCodes}
        products={products}
      />
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    files: state.firmware.files,
    fileTypes: state.firmware.fileTypes,
    activityLogs: state.firmware.activityLogs,
  };
};

const mapDispatchToProps = {
  DeleteFile,
  GetChecksum,
  GetFileTypes,
  GetList,
  UpdateFile,
  UploadFile,
  DownloadReleaseNotes,
  GetLanguageCodes,
  getProductOptions,
};

export default connect(mapStateToProps, mapDispatchToProps)(FirmwareView);
